// Ubicación en el repo: src/components/TrendChartSVG.jsx
// Gráfico de tendencia del Dashboard — mismo layout que drawTrendChartSVG()
// del prototipo (línea ~689): barras agrupadas por mes, una barra por
// serie. `months` es un array de 'YYYY-MM'; `series` es
// [{ label, color, data }], con `data` alineado 1 a 1 con `months`.
const W = 560;
const H = 240;
const PAD_L = 34;
const PAD_R = 16;
const PAD_T = 16;
const PAD_B = 32;
const PLOT_W = W - PAD_L - PAD_R;
const PLOT_H = H - PAD_T - PAD_B;
const MONO = "'JetBrains Mono', monospace";

function monthShortLabel(monthStr) {
  const [yy, mm] = monthStr.split('-');
  return new Date(Number(yy), Number(mm) - 1, 1).toLocaleDateString('es-CL', { month: 'short' });
}

export default function TrendChartSVG({ months, series }) {
  const maxVal = Math.max(1, ...series.flatMap((s) => s.data));
  const groupW = PLOT_W / months.length;
  const barW = groupW / (series.length + 1);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ maxWidth: 560 }}>
      <line x1={PAD_L} y1={PAD_T + PLOT_H} x2={W - PAD_R} y2={PAD_T + PLOT_H} stroke="#DCE3E5" strokeWidth={1} />
      {months.map((m, i) => {
        const showLabel = months.length <= 6 || i % 2 === 0;
        const labelX = PAD_L + i * groupW + groupW / 2;
        return (
          <g key={m}>
            {series.map((s, si) => {
              const val = s.data[i] ?? 0;
              const barH = maxVal > 0 ? (val / maxVal) * PLOT_H : 0;
              const x = PAD_L + i * groupW + si * barW + barW * 0.5;
              const y = PAD_T + PLOT_H - barH;
              return (
                <g key={s.label}>
                  <rect x={x} y={y} width={barW * 0.85} height={Math.max(barH, 1)} fill={s.color} rx={2} />
                  {val > 0 && (
                    <text x={x + barW * 0.42} y={y - 4} fontSize={9.5} textAnchor="middle" fill="#5B6B6E" fontFamily={MONO}>
                      {val}
                    </text>
                  )}
                </g>
              );
            })}
            {showLabel && (
              <text
                x={labelX}
                y={H - PAD_B + 16}
                fontSize={10.5}
                textAnchor="middle"
                fill="#5B6B6E"
                style={{ textTransform: 'capitalize' }}
              >
                {monthShortLabel(m)}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
